import React from 'react';
import CellBackground from './CellBackground';
import { connect } from 'react-redux';
import { Alert } from "react-bootstrap";
import { clearCommands } from "./state/tableSquaresState";

class CommandLines extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            ask: false,
            num: 0,
        };

        this.increaseNum = () => {
            let num = this.state.num + 1;
            this.setState({ num: num })
        };

        this.createTable = x => {
            let rows = [];
            let tableLength = x.length;
            for (let r = 0; r < tableLength; r++) {
                let cells = [];
                for (let c = 0; c < x[r].length; c++) {
                    cells.push(
                        <CellBackground
                            increaseNum={this.increaseNum}
                            key={r + '' + c}
                            posX={r}
                            posY={c}
                            krazekId={x[r][c]}
                            command={true}
                        />
                    )
                }
                rows.push(<tr key={r}>{cells}</tr>)
            }

            return rows;
        };

        this.handleClear = () => {
            this.props.clearCommands();
            this.props.increaseNum();
            this.setState({ ask: false })
        };

        this.askUser = () => {
            this.setState({ ask: true })
        };

        this.handleDismiss = () => {
            this.setState({ ask: false })
        };
    }

    render() {
        let content = '';
        if (this.state.ask) {
            content =
                <div id="alertOnClear">
                    <Alert bsStyle="warning">
                        <p style={{
                            'margin': '0 0 1.4rem 0',
                            'color': '#ffffff',
                            'fontFamily': 'Robota, sans-serif'
                        }}>Czy na pewno chcesz wyczyścić listę komend?</p>
                        <div className="d-flex flex-row justify-content-between">
                            <button id="confirmClear" className="btn" onClick={this.handleClear}>Tak, wyczyść
                                listę
                            </button>
                            <button id="rejectClear" className="btn" onClick={this.handleDismiss}>Nie</button>
                        </div>
                    </Alert>
                </div>
        }
        if (this.props.active_Table === 'SQUARES') {
            return (
                <div className="comand-lines">
                    <table onClick={this.props.handleShowAlert}>
                        <tbody>
                            {this.createTable(this.props.commands)}
                        </tbody>
                    </table>
                    <button id="btnCommandClear" onClick={this.askUser}>Wyczyść listę komend</button>
                    {content}
                </div>
            )
        }
        else return '';
    }
}

export default connect(
    state => ({
        active_Table: state.activeTable,
    }),
    { clearCommands }
)(CommandLines)



// WEBPACK FOOTER //
// ./src/CommandLines.js